var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-col',{attrs:{"cols":"12"}},[_c('v-row',{attrs:{"justify":"center"}},[_c('v-col',{staticStyle:{"text-align-last":"center"},attrs:{"cols":"12","lg":"12","md":"12"}},[_c('iframe',{attrs:{"title":"Reporte Comercial","width":"1000","height":"541.25","src":_vm.src,"frameborder":"0","allowFullScreen":"true"}})])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }